<div class="container">
  <h1>REQUEST APPOINTMENT</h1>
  <form [formGroup]='requestForm'>
    <div class="container" id="formerrors">
      <div class="row line">
        <div class="col-md-12 col-sm-12">
          <p>Whom would you like to book for ?</p>

          <div class="btn-group">
            <button type="button" class="btn" data-toggle="collapse"
              [ngClass]="typeToWhom == 'MYSELF'? 'Col_Green':'Col_Grey'"
              (click)="getValues({typename :'MYSELF'}) ;isToggle=true" data-target="#myself">My self</button>
          </div>
          <div class="btn-group">
            <button type="button" class="btn" data-toggle="collapse"
              [ngClass]="typeToWhom == 'FAMILY'? 'Col_Green':'Col_Grey'"
              (click)="getValues({typename :'FAMILY'}); isToggle=false" data-target="#family">Other</button>
          </div>
          <div *ngIf="!requestForm.get('toWhom').valid && requestForm.get('toWhom').touched">
            <small class="error outside_Div">whom you are?</small>
          </div>

          <div id="myself" class="collapse" *ngIf="isToggle">
            <form formGroupName='detailsDto'>
              <div class="row row1">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label>First Name</label>
                  <input type="text" class="form-control" formControlName='firstName'>
                  <div
                    *ngIf="!requestForm.get('detailsDto.firstName').valid && requestForm.get('detailsDto.firstName').touched">
                    <small class="error">Firstname should not be empty</small>
                  </div>
                  <!-- <div
                    *ngIf="!requestForm.get('detailsDto.firstName').hasError('minlength')&& !requestForm.get('detailsDto.firstName').touched">
                    <small class="error">Firstname should contain minimum 3 characters</small>
                  </div>
                  <div
                    *ngIf="!requestForm.get('detailsDto.firstName').hasError('maxlength')&& !requestForm.get('detailsDto.firstName').touched">
                    <small class="error">Firstname should contain maximum 35 characters</small>
                  </div>
                  <div
                    *ngIf="!requestForm.get('detailsDto.firstName').hasError('pattern')&& !requestForm.get('detailsDto.firstName').touched">
                    <small class="error">Please enter only alphabets</small>
                  </div> -->
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label>Last Name:</label>
                  <input type="text" class="form-control" formControlName='lastName'>
                  <div
                    *ngIf="!requestForm.get('detailsDto.lastName').valid && requestForm.get('detailsDto.lastName').touched">
                    <small class="error">Lastname should not be empty</small>
                  </div>
                  <!-- <div
                    *ngIf="!requestForm.get('detailsDto.lastName').hasError('minlength')&& !requestForm.get('detailsDto.lastName').touched">
                    <small class="error">Lastname should contain minimum 3 characters</small>
                  </div>
                  <div
                    *ngIf="!requestForm.get('detailsDto.lastName').hasError('maxlength')&& !requestForm.get('detailsDto.lastName').touched">
                    <small class="error">Lastname should contain maximum 35 characters</small>
                  </div>
                  <div
                    *ngIf="!requestForm.get('detailsDto.lastName').hasError('pattern')&& !requestForm.get('detailsDto.lastName').touched">
                    <small class="error">Please enter only alphabets</small>
                  </div> -->
                </div>
              </div>

              <div class="row row1">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label>DOB:</label>
                  <input type="date" class="form-control" formControlName='dob' placeholder="DD/MM/YYYY"
                    min="1920-01-01" max="{{maxdate| date:'yyyy-MM-dd'}}">
                  <div *ngIf="!requestForm.get('detailsDto.dob').valid && requestForm.get('detailsDto.dob').touched">
                    <small class="error">Please fill the DOB</small>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label for="gen">Gender:</label>
                  <select id="gen" name="rel" class="form-control" formControlName='genderId'>
                    <option value="null" disabled>select</option>
                    <ng-container *ngFor="let gender of gender">
                      <option value="{{gender?.genderId}}">{{gender?.genderName}}</option>
                    </ng-container>
                  </select>
                  <div
                    *ngIf="!requestForm.get('detailsDto.genderId').valid && requestForm.get('detailsDto.genderId').touched">
                    <small class="error">Please select the gender</small>
                  </div>
                </div>
              </div>

              <div class="row row1">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label for="rel">Phone:</label>
                  <input type="text" class="form-control" maxlength="10" formControlName='phoneNumber'>
                  <div
                    *ngIf="!requestForm.get('detailsDto.phoneNumber').valid&& requestForm.get('detailsDto.phoneNumber').touched">
                    <small class="error">Please enter phone number</small>
                  </div>
                  <!-- <div
                    *ngIf="!requestForm.get('detailsDto.phoneNumber').hasError('pattern')&& !requestForm.get('detailsDto.phoneNumber').touched;else test">
                    <small class="error">Please enter in digits</small>
                  </div> -->
                  <ng-template #test>
                    <div
                      *ngIf="!requestForm.get('detailsDto.phoneNumber').hasError('minlength')&& !requestForm.get('detailsDto.phoneNumber').touched">
                      <small class="error">Please enter minimum 10 digits</small>
                    </div>
                    <div
                      *ngIf="!requestForm.get('detailsDto.phoneNumber').hasError('maxlength')&& !requestForm.get('detailsDto.phoneNumber').touched">
                      <small class="error">Please enter maximum 10 digits</small>
                    </div>
                  </ng-template>
                </div>
              </div>
            </form>
            <div class="row row1">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <label for="rel">Refered By:</label>
                <input type="text" class="form-control" formControlName='refferedBy'>
              </div>
            </div>
          </div>


          <div id="family" class="collapse" *ngIf="!isToggle">
            <form formGroupName='detailsDto'>

              <div class="row row1">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label>First Name</label>
                  <input type="text" class="form-control" formControlName='firstName'>
                  <div
                    *ngIf="!requestForm.get('detailsDto.firstName').valid && requestForm.get('detailsDto.firstName').touched">
                    <small class="error">Firstname should not be empty</small>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label>Last Name:</label>
                  <input type="text" class="form-control" formControlName='lastName'>
                  <div
                    *ngIf="!requestForm.get('detailsDto.lastName').valid && requestForm.get('detailsDto.lastName').touched">
                    <small class="error">Lastname should not be empty</small>
                  </div>
                </div>
              </div>

              <div class="row row1">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label>DOB:</label>
                  <input type="date" class="form-control" formControlName='dob' placeholder="DD/MM/YYYY"
                    min="1920-01-01" max="{{maxdate| date:'yyyy-MM-dd'}}">
                  <div *ngIf="!requestForm.get('detailsDto.dob').valid && requestForm.get('detailsDto.dob').touched">
                    <small class="error">Please fill the DOB</small>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label for="gen1">Gender:</label>
                  <select id="gen1" name="gendername" class="form-control" formControlName='genderId'>
                    <option value='null' disabled>Select</option>
                    <option *ngFor="let gender of gender" value="{{gender?.genderId}}">{{gender?.genderName}}</option>
                  </select>
                  <div
                    *ngIf="!requestForm.get('detailsDto.genderId').valid && requestForm.get('detailsDto.genderId').touched">
                    <small class="error">Please select the gender</small>
                  </div>
                </div>
              </div>

              <div class="row row1">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label for="rel">Phone:</label>
                  <input type="text" class="form-control" formControlName='phoneNumber' maxlength="10">
                  <div
                    *ngIf="!requestForm.get('detailsDto.phoneNumber').valid&& requestForm.get('detailsDto.phoneNumber').touched">
                    <small class="error">Please enter phone number</small>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <label for="rel">RelationShip:</label>
                  <select id="rel" name="rel" class="form-control" formControlName="relation">
                    <option value='null' disabled>Select</option>
                    <option value="FATHER">Father</option>
                    <option value="MOTHER">Mother</option>
                    <option value="GRANDFATHER">GrandFather</option>
                    <option value="GRANDMOTHER">GrandMother</option>
                    <option value="SON">Son</option>
                    <option value="DAUGHTER">Daughter</option>
                    <option value="OTHERS">Other</option>
                  </select>
                </div>
              </div>
            </form>
            <div class="row row1">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <label for="rel">Refered By:</label>
                <input type="text" class="form-control" formControlName='refferedBy'>
              </div>
            </div>
          </div>

        </div>
      </div>
   <ng-container *ngIf="typeToWhom !=''">

      <div class="row line">
        <div class="col-md-12  col-sm-12">
          <p>What mode of consultation would you prefer ?</p>

          <div class="btn-group">
            <button type="button" class="btn " [ngClass]="typeMode== 'Video'? 'Col_Green':'Col_Grey'"
              (click)="getValues({mode :'Video'})">Video</button>
          </div>
          <!-- <div class="btn-group">
            <button type="button" class="btn" [ngClass]="typeMode == 'Audio'? 'Col_Green':'Col_Grey'"
              (click)="getValues({mode :'Audio'})">Audio</button>
          </div>
          <div class="btn-group">
            <button type="button" class="btn" [ngClass]="typeMode == 'Email'? 'Col_Green':'Col_Grey'"
              (click)="getValues({mode :'Email'})">Email</button>
          </div> -->

          <div *ngIf="!requestForm.get('modeOfConsultation').valid && requestForm.get('modeOfConsultation').touched">
            <small class="error outside_Div">Select the mode of consult to doctor</small>
          </div>
        </div>
      </div>

      <div class="row line">
        <div class="col-md-12  col-sm-12">
          <p>Would you like to book an appointment today or schedule it at another time ?
            <!-- <br/>We are available from Monday to Sunday 6:00 AM to 10:00 PM</p> -->

          <div>
            <input class="date" formControlName="appointmentDate" (click)="openModal(appointmentSchduler)">
            <div *ngIf="!requestForm.get('appointmentDate').valid&& requestForm.get('appointmentDate').touched" >
              <small class="error">Appointment date should not be empty</small>
            </div>
          </div>
        </div>
      </div>

      <div class="row line">
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6">
          <div class="text">
            <!-- <span><span class="glyphicon glyphicon-camera"><input type="file" title="" /></span> Medical Records</span> -->
            <label for="files" class="files">
              Medical Records</label>
              <div class="upload-btn-wrapper">
                <button class="button" class="btn btn-default "><i class="bi bi-arrow-up-circle"></i>
                <input type="file" title=" " class="form-control" name="addressproof" multiple [accept]="acceptFilesFormat" (change)="fileUpload($event)"/>
                <p *ngFor="let file of fileName;let i=index">
                  <small>{{file.name}}<a (click)="removeFile(file)"><i class="bi bi-x-circle-fill"></i></a></small>
                </p></button>
              </div>
          </div>
          <!-- <div class="filename" *ngIf="fileName.length">
            <ng-container *ngFor="let file of fileName;let i=index">
              <small>{{file.name}} {{'&nbsp;'}}<a style="cursor: pointer;" (click)="removeFile(file)">X {{i ===
                  fileName.length-1 ? '' : ',&nbsp;'}}</a></small>
            </ng-container>
          </div> -->
        </div>
        <div class="col-lg-8 col-md-8 col-sm-6 col-xs-6">
          <div class="boxleft">
            <label>Additional Info</label>
            <div class="form-group">
              <textarea class="form-control" id="exampleFormControlTextarea5" rows="3"
                formControlName="additionalInfo"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="row line">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <button type="button" class="btn searchbutton" class="searchnew" (click)="submitReq_Form()">submit</button>
        </div>
      </div>

    </ng-container>
    </div>







    <!-- (click)="openModal(appointmentSchduler)"

-->
    <ng-template #appointmentSchduler>
      <div class="calendar-container">
        <div class="row">
          <p class="col-md-4 text-left"></p>
          <h4 class="col-md-4 text-center title">Appointment Calendar</h4>
          <i (click)="modalService.hide()" class="bi bi-x-circle"></i>
          <!-- <button type="button" class="col-md-1 cancelBtn" (click)="modalService.hide()">cancel</button> -->
        </div>
        <div class="row mt-4">
          <div class="col-md-6 col-sm-6 col-xs-6 text-left">
            <h3 class="mt-0">{{ viewDate | calendarSchedulerDate:(view +
              'ViewTitle'):locale:weekStartsOn:excludeDays:viewDays:startsWithToday }}</h3>
            <!-- <select #viewDayOptionSelect1 class="form-control d-none d-md-block d-xl-none" [(ngModel)]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect1.value)">
                <option [value]="1">Un giorno</option>
                <option [value]="3">Tre giorni</option>
                <option [value]="7">Una settimana</option>
            </select> -->

          </div>
          <div class="col-md-6 col-sm-6 col-xs-6 margintop text-right">
            <div class="row ">
              <div class="col-6 d-md-none d-xl-flex col-xl-6 valign-center text-right">
                <!-- <select #viewDayOptionSelect2 class="form-control m-1" [ngModel]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect2.value)">
                  <option [value]="1">Un giorno</option>
                  <option [value]="3">Tre giorni</option>
                  <option [value]="7">Una settimana</option>
              </select> -->
              </div>
              <div class="col-6 col-md-12 col-xl-6">
                <div class="btn-group m-1" role="group">
                  <button type="button" class="btn btn-primary btnFont" mwlCalendarPreviousView [view]="view"
                    [(viewDate)]="viewDate" [daysInWeek]="viewDays" [excludeDays]="excludeDays"
                    [disabled]="prevBtnDisabled" (viewDateChange)="dateOrViewChanged()"
                    (click)="getSchedular(viewDate)">
                    <span class="valign-center">
                      <i class="bi bi-chevron-left">Previous</i>
                    </span>
                  </button>
                  <button type="button" class="btn btn-primary btnFont" mwlCalendarToday [(viewDate)]="viewDate"
                    (viewDateChange)="dateOrViewChanged()" (click)="getSchedular(viewDate)">
                    <span class="valign-center">
                      <i class="">Today</i>
                    </span>
                  </button>
                  <button type="button" class="btn btn-primary btnFont" mwlCalendarNextView [view]="view"
                    [(viewDate)]="viewDate" [daysInWeek]="viewDays" [excludeDays]="excludeDays"
                    [disabled]="nextBtnDisabled" (viewDateChange)="dateOrViewChanged()"
                    (click)="getSchedular(viewDate)">

                    <span class="valign-center">
                      <i class="bi bi-chevron-right">Next</i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <calendar-scheduler-view [viewDays]="viewDays" [viewDate]="viewDate" [events]="events" [locale]="locale"
            [responsive]="false" [weekStartsOn]="weekStartsOn" [excludeDays]="excludeDays"
            [startsWithToday]="startsWithToday" [hourSegments]="hourSegments" [dayStartHour]="dayStartHour"
            [dayEndHour]="dayEndHour" [dayModifier]="dayModifier" [hourModifier]="hourModifier"
            [segmentModifier]="segmentModifier" [eventModifier]="eventModifier" [showEventActions]="true"
            [showSegmentHour]="true" [zoomEventOnHover]="true" (viewDaysChanged)="viewDaysChanged($event)"
            (dayHeaderClicked)="dayHeaderClicked($event.day)"
            (segmentClicked)="segmentClicked('Clicked', $event.segment)"
            (eventClicked)="eventClicked('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)"
            [refresh]="refresh">

          </calendar-scheduler-view>
        </div>


      </div>


      <!-- (hourClicked)="hourClicked($event.hour)" -->

    </ng-template>

    <ng-template #msg>
      <!-- Modal Header -->
      <div class="modal-header1">
        <h4 class="modal-title1">Message</h4>
        <!-- <button type="button" class="closeModal" data-dismiss="modal" (click)="modalService.hide()"><i
            class="bi bi-x-circle"></i></button> -->
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <p class="text-center">{{modalService.config.initialState.message}}</p>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer1">
        <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
        <button type="button" class="btn-blue" (click)="modalService.hide()">OK</button>
      </div>
  
    </ng-template>